module.exports = __webpack_public_path__ + "media/images/shared/ad/header1-39a5869b35103daf22a85d1a965d1aa3.jpg";